module.exports = __webpack_public_path__ + "static/media/EmptyBlockTarget.48653a49.svg";